import columnTypes from '../columnTypes.js';
import types from '../types.js';

const combinedPAMTables = [
  {
    key: 'Violation-Stock-And-Flow',
    name: 'Violation Stock And Flow',
    [columnTypes.default.key]: [
      {
        source: 'MetricDate',
        rename: 'Metric Date',
        type: types.date,
      },
      {
        source: 'StockCount',
        rename: 'Stock Count',
        type: types.number,
      },
      {
        source: 'FlowCount',
        rename: 'Flow Count',
        type: types.number,
      },
      {
        source: 'RemediationsCount',
        rename: 'Remediations Count',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [],
  },
  {
    key: 'pam-account-granular',
    name: 'PAM Account Granular Details',
    [columnTypes.default.key]: [
      { source: 'AccountName', rename: 'Account Name', type: types.text },
      { source: 'AccountSource', rename: 'Account Source', type: types.text },
      { source: 'DomainName', rename: 'Domain', type: types.text },
      { source: 'AccountType', rename: 'Account Type', type: types.text },
      { source: 'Status', rename: 'Status', type: types.text },
      {
        source: 'ControlsApplied',
        rename: 'Controls Applied',
        type: types.text,
      },
      {
        source: 'Violations',
        rename: 'Control Violations',
        type: types.number,
      },
      { source: 'Exceptions', rename: 'Exceptions', type: types.number },
      { source: 'AccountOwnerName', rename: 'Owner', type: types.text },
      { source: 'OwnerDivision', rename: 'Business Unit', type: types.text },
      { source: 'OSs', rename: 'Servers', type: types.number },
      { source: 'Applications', rename: 'Applications', type: types.number },
      {
        source: 'Databases',
        rename: 'Database Instances',
        type: types.number,
      },
      {
        source: 'ServiceDependencies',
        rename: 'ServiceDependencies',
        type: types.number,
      },
      { source: 'PAMr', rename: 'PAMr', type: types.text },
      {
        source: 'PrivilegeAccessInstancesCount',
        rename: 'Privilege Access Instances',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'DistinguishedName',
        rename: 'Distinguished Name',
        type: types.text,
      },
      {
        source: 'AccountOwnershipStatus',
        rename: 'Ownership Type',
        type: types.text,
      },
      {
        source: 'AccountOwnershipUpdatedDate',
        rename: 'Ownership Updated Date',
        type: types.date,
      },
      {
        source: 'UserPrincipalName',
        rename: 'UserPrincipalName',
        type: types.text,
      },
      { source: 'ADDescription', rename: 'ADDescription', type: types.text },
      { source: 'ObjectSid', rename: 'ObjectSid', type: types.text },
      { source: 'DisplayName', rename: 'DisplayName', type: types.text },
      { source: 'Cn', rename: 'Cn', type: types.text },
      { source: 'SAMAccountType', rename: 'SAMAccountType', type: types.text },
      { source: 'Info', rename: 'Info', type: types.text },
      {
        source: 'ExtensionAttribute1',
        rename: 'ExtensionAttribute1',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute2',
        rename: 'ExtensionAttribute2',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute3',
        rename: 'ExtensionAttribute3',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute4',
        rename: 'ExtensionAttribute4',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute5',
        rename: 'ExtensionAttribute5',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute6',
        rename: 'ExtensionAttribute6',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute7',
        rename: 'ExtensionAttribute7',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute8',
        rename: 'ExtensionAttribute8',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute9',
        rename: 'ExtensionAttribute9',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute10',
        rename: 'ExtensionAttribute10',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute11',
        rename: 'ExtensionAttribute11',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute12',
        rename: 'ExtensionAttribute12',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute13',
        rename: 'ExtensionAttribute13',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute14',
        rename: 'ExtensionAttribute14',
        type: types.text,
      },
      {
        source: 'ExtensionAttribute15',
        rename: 'ExtensionAttribute15',
        type: types.text,
      },
      {
        source: 'UserAccountControl',
        rename: 'UserAccountControl',
        type: types.text,
      },
      {
        source: 'LastPasswordSet',
        rename: 'LastPasswordSet',
        type: types.date,
      },
      { source: 'AccountExpires', rename: 'AccountExpires', type: types.text },
      { source: 'LastLogon', rename: 'LastLogon', type: types.date },
      {
        source: 'LastLogonTimeStamp',
        rename: 'LastLogonTimeStamp',
        type: types.date,
      },
      { source: 'WhenCreated', rename: 'WhenCreated', type: types.date },
      { source: 'WhenChanged', rename: 'WhenChanged', type: types.date },
      { source: 'EmployeeID', rename: 'EmployeeID', type: types.text },
      { source: 'EmpID', rename: 'EmpID', type: types.text },
      { source: 'EmployeeType', rename: 'EmployeeType', type: types.text },
      { source: 'Mail', rename: 'Mail', type: types.text },
      { source: 'MailNickname', rename: 'MailNickname', type: types.text },
      {
        source: 'MsExchHideFromAddressLists',
        rename: 'MsExchHideFromAddressLists',
        type: types.text,
      },
      {
        source: 'MsExchRequireAuthToSendTo',
        rename: 'MsExchRequireAuthToSendTo',
        type: types.text,
      },
      {
        source: 'MsExchMailboxGuid',
        rename: 'MsExchMailboxGuid',
        type: types.text,
      },
      {
        source: 'ServicePrincipalName',
        rename: 'ServicePrincipalName',
        type: types.text,
      },
      { source: 'Name', rename: 'Name', type: types.text },
      { source: 'Ou', rename: 'OU', type: types.text },
    ],
    [columnTypes.hidden.key]: [
      { source: 'selectable', rename: 'selectable' },
      { source: 'noSelectMessage', rename: 'noSelectMessage' },
      { source: 'AccountId', rename: 'AccountId' },
      { source: 'Scope', rename: 'Scope' },
      { source: 'AccountOwnerId', rename: 'AccountOwnerId' },
      { source: 'AccountOwnerType', rename: 'AccountOwnerType' },
      { source: 'EntityType', rename: 'EntityType' },
      { source: 'AccountSTSGuid', rename: 'AccountSTSGuid' },
      { source: 'AccountOwnerSTSGuid', rename: 'AccountOwnerSTSGuid' },
      { source: 'Campaign', rename: 'Campaign' },
    ],
  },
];

export default [...combinedPAMTables];
